// @flow

import GraphQLPagination from './GraphQLPagination';

export type {
  PageInfo,
  Props as GraphQLPaginationProps,
} from './GraphQLPagination';
export default GraphQLPagination;
